/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL21haW4vaHIvdHJhbnNsYXRvci90cmFuc2xhdG9yLW9yaWVudGF0aW9uL3RyYW5zbGF0b3Itb3JpZW50YXRpb24uY29tcG9uZW50LnNjc3MifQ== */"];
export { styles as styles };
